import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

export interface MFDListProps {
  Nombre: string;
  Codigo: number;
}

let financialMovementDescApiPromise: Promise<AxiosInstance> | null = null;

const getFinancialMovementsDescApi = () => {
  if (financialMovementDescApiPromise) return financialMovementDescApiPromise;
  financialMovementDescApiPromise = createAxiosWithAuth(BASE_URL);
  return financialMovementDescApiPromise;
};

export const getFinancialMovementDescList = async (props: MFDListProps) => {
  const api = await getFinancialMovementsDescApi();
  if (!api) return null;
  const response = await api.get(
    `/MovimientosFinancierosDescripcion/Listado?${objectToQueryStringWithArray(props)}`,
  );

  return response?.data;
};

export interface GetMFDDetailProps {
  Codigo: number;
}

export const getFinancialMovementDescDetail = async (
  props: GetMFDDetailProps,
) => {
  const api = await getFinancialMovementsDescApi();
  if (!api) return null;
  const response = await api.get(
    `/MovimientosFinancierosDescripcion?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export const getExistingFinancialMovementDesc = async () => {
  const api = await getFinancialMovementsDescApi();
  if (!api) return null;
  const response = await api.get(
    `/MovimientosFinancierosDescripcion/Existentes`,
  );

  return response.data;
};

export interface CreateMFDProps {
  nombre: string;
  codigo: number;
}

export const createMFD = async (props: CreateMFDProps) => {
  const api = await getFinancialMovementsDescApi();
  if (!api) return null;
  const response = await api.post(
    `/MovimientosFinancierosDescripcion/Crear?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface UpdateMFDProps {
  codigo: number;
  nombre: string;
}

export const updateMFD = async (props: UpdateMFDProps) => {
  const api = await getFinancialMovementsDescApi();
  if (!api) return null;
  const response = await api.put(
    `/MovimientosFinancierosDescripcion/Actualizar?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface DeleteMFDProps {
  Codigos: number[];
}

export const deleteMFD = async (props: DeleteMFDProps) => {
  const api = await getFinancialMovementsDescApi();
  if (!api) return null;
  const response = await api.delete(
    `/MovimientosFinancierosDescripcion/Eliminar?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};
